import { makeStyles, shorthands } from "@fluentui/react-components";

export const useStyles = makeStyles({
    root: {
        marginLeft: "10px",
        ...shorthands.padding("20px")
    }
});
